import Navbar from "components/Navbar";
import SearchBar from "components/SearchBar";
import Text from "components/Text";
import { FC } from "react";
import { HiOutlineShieldCheck } from "react-icons/hi";
import { RiUserLine } from "react-icons/ri";
import { TbClipboardCheck } from "react-icons/tb";
import theme from "theme";
import {
    HelpCenterCard,
    HelpCenterContent,
    HelpCenterHeader,
    HelpCenterWrapper,
} from "./HelpCenter.styled";

export const HelpCenter: FC = () => {
    return (
        <HelpCenterWrapper>
            <Navbar />
            <HelpCenterHeader>
                <Text
                    variant="heading1"
                    fontSize="30px"
                    fontWeight="800"
                    color={theme.colors.grey.dark}
                >
                    Help Center
                </Text>
                <SearchBar variant="normal" />
            </HelpCenterHeader>
            <HelpCenterContent>
                <HelpCenterCard>
                    <RiUserLine />
                    <Text variant="body2" fontWeight="600">
                        Manage Your Account
                    </Text>
                    <Text
                        variant="body3"
                        fontSize="10px"
                        color={theme.colors.grey.secondary}
                    >
                        Dolor qui nulla repudiandae conseq uatur fuga aspe
                        riores.
                    </Text>
                </HelpCenterCard>
                <HelpCenterCard>
                    <HiOutlineShieldCheck />
                    <Text variant="body2" fontWeight="600">
                        Safety and Privacy
                    </Text>
                    <Text
                        variant="body3"
                        fontSize="10px"
                        color={theme.colors.grey.secondary}
                    >
                        Dolor qui nulla repudiandae conseq uatur fuga aspe
                        riores.
                    </Text>
                </HelpCenterCard>
                <HelpCenterCard>
                    <TbClipboardCheck />
                    <Text variant="body2" fontWeight="600">
                        Terms and Conditions
                    </Text>
                    <Text
                        variant="body3"
                        fontSize="10px"
                        color={theme.colors.grey.secondary}
                    >
                        Dolor qui nulla repudiandae conseq uatur fuga aspe
                        riores.
                    </Text>
                </HelpCenterCard>
                <HelpCenterCard>
                    <RiUserLine />
                    <Text variant="body2" fontWeight="600">
                        Manage Your Account
                    </Text>
                    <Text
                        variant="body3"
                        fontSize="10px"
                        color={theme.colors.grey.secondary}
                    >
                        Dolor qui nulla repudiandae conseq uatur fuga aspe
                        riores.
                    </Text>
                </HelpCenterCard>
                <HelpCenterCard>
                    <HiOutlineShieldCheck />
                    <Text variant="body2" fontWeight="600">
                        Safety and Privacy
                    </Text>
                    <Text
                        variant="body3"
                        fontSize="10px"
                        color={theme.colors.grey.secondary}
                    >
                        Dolor qui nulla repudiandae conseq uatur fuga aspe
                        riores.
                    </Text>
                </HelpCenterCard>
                <HelpCenterCard>
                    <TbClipboardCheck />
                    <Text variant="body2" fontWeight="600">
                        Terms and Conditions
                    </Text>
                    <Text
                        variant="body3"
                        fontSize="10px"
                        color={theme.colors.grey.secondary}
                    >
                        Dolor qui nulla repudiandae conseq uatur fuga aspe
                        riores.
                    </Text>
                </HelpCenterCard>
            </HelpCenterContent>
        </HelpCenterWrapper>
    );
};
